import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query'
import { useQueryClient } from './useQueryClient'

type Props = {
  children: React.ReactNode
}

function QueryClientProvider({ children }: Props) {
  const queryClient = useQueryClient()
  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
    </TanstackQueryClientProvider>
  )
}

export { QueryClientProvider }
